// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-bracket-desktop-team-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #002129;
  border-radius: 4px;
  width: 200px;
  height: 40px;
  min-height: 40px;
  gap: 5px;
  box-sizing: border-box;
  cursor: pointer;
}

.super-pickem-bracket-desktop-team-row-placeholder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #002129;
  border-radius: 4px;
  width: 200px;
  height: 40px;
  gap: 5px;
  box-sizing: border-box;
}

.super-pickem-bracket-desktop-team-seed {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: #002129;
  border-radius: 4px;
}
.super-pickem-bracket-desktop-team-seed .seed-number {
  font-size: 20px;
  font-weight: 500;
  color: #CD942E;
}

.super-pickem-bracket-desktop-team-logo-placeholder {
  width: 30px;
  height: 30px;
  background-color: transparent;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.super-pickem-bracket-desktop-team-logo-placeholder .team-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.super-pickem-bracket-desktop-team-name {
  text-align: center;
  display: flex;
  width: 135px;
  height: 30px;
  justify-content: center;
  align-items: center;
  text-align: left;
}
.super-pickem-bracket-desktop-team-name .team-name {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}

.super-pickem-live-bracket-desktop-team-name {
  text-align: center;
  display: flex;
  width: 95px;
  height: 30px;
  justify-content: center;
  align-items: center;
  text-align: left;
}
.super-pickem-live-bracket-desktop-team-name .team-name {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-live-bracket-desktop-team-score {
  text-align: center;
  display: flex;
  width: 40px;
  height: 38px;
  justify-content: center;
  border-left: 1px solid #002129;
  align-items: center;
}
.super-pickem-live-bracket-desktop-team-score .team-score {
  font-size: 14px;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-live-bracket-desktop-team-name-loser {
  text-align: center;
  display: flex;
  height: 30px;
  justify-content: center;
  align-items: center;
  text-align: left;
}
.super-pickem-live-bracket-desktop-team-name-loser .team-name-loser {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.super-pickem-bracket-desktop-game-container {
  width: 230px;
  height: 130px;
  background-color: #D9D9D9;
  border-radius: 4px;
  border: 1px solid #002129;
  display: flex;
  flex-direction: column; /* Arrange children in a column */
  justify-content: space-between; /* Space out the rows evenly */
  align-items: center; /* Center content horizontally */
  padding: 10px; /* Add some padding for spacing */
  box-sizing: border-box; /* Include padding in width/height calculations */
  position: relative;
}
.super-pickem-bracket-desktop-game-container::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
  height: 2px;
  background-color: black;
}
.super-pickem-bracket-desktop-game-container::before {
  content: "";
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
  height: 2px;
  background-color: black;
}

.super-pickem-bracket-desktop-game-container-desktop {
  width: 206px;
  height: 130px;
  background-color: #D9D9D9;
  border-radius: 4px;
  border: 1px solid #002129;
  display: flex;
  flex-direction: column; /* Arrange children in a column */
  justify-content: space-between; /* Space out the rows evenly */
  align-items: center; /* Center content horizontally */
  padding: 10px; /* Add some padding for spacing */
  box-sizing: border-box; /* Include padding in width/height calculations */
  position: relative;
  margin-left: 9px;
}
.super-pickem-bracket-desktop-game-container-desktop::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 2px;
  background-color: black;
}
.super-pickem-bracket-desktop-game-container-desktop::before {
  content: "";
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 2px;
  background-color: black;
}

.regional-bracket-desktop-column-games-third.right .super-pickem-bracket-desktop-game-container::after {
  display: none;
}
.regional-bracket-desktop-column-games-third.right .super-pickem-bracket-desktop-game-container-desktop::after {
  display: none;
}

.regional-bracket-desktop-column-games-third.left .super-pickem-bracket-desktop-game-container::before {
  display: none;
}
.regional-bracket-desktop-column-games-third.left .super-pickem-bracket-desktop-game-container-desktop::before {
  display: none;
}

.regional-bracket-desktop-column-games-first .super-pickem-bracket-desktop-game-container::before {
  display: none;
}
.regional-bracket-desktop-column-games-first .super-pickem-bracket-desktop-game-container-desktop::before {
  display: none;
}

.regional-bracket-desktop-column-games-first-desktop-left .super-pickem-bracket-desktop-game-container-desktop::after {
  display: none;
}

.regional-bracket-desktop-column-games-first-desktop-right .super-pickem-bracket-desktop-game-container::after {
  display: none;
}
.regional-bracket-desktop-column-games-first-desktop-right .super-pickem-bracket-desktop-game-container-desktop::after {
  display: none;
}

.regional-bracket-desktop-column-games-final .super-pickem-bracket-desktop-game-container::after {
  display: none;
}
.regional-bracket-desktop-column-games-final .super-pickem-bracket-desktop-game-container-desktop::after {
  display: none;
}
.regional-bracket-desktop-column-games-final .super-pickem-bracket-desktop-game-container::before {
  display: none;
}
.regional-bracket-desktop-column-games-final .super-pickem-bracket-desktop-game-container-desktop::before {
  display: none;
}

.final-four-left .super-pickem-bracket-desktop-game-container::before {
  display: none;
}

.final-four-right .super-pickem-bracket-desktop-game-container::after {
  display: none;
}

.super-pickem-bracket-desktop-champ-container {
  width: 219px;
  height: 245px;
  background-color: #D9D9D9;
  border-radius: 4px;
  border: 1px solid #002129;
  display: flex;
  flex-direction: column; /* Arrange children in a column */
  justify-content: space-between; /* Space out the rows evenly */
  align-items: center; /* Center content horizontally */
  padding: 10px; /* Add some padding for spacing */
  margin-top: -120px;
  margin-bottom: 79px;
  box-sizing: border-box; /* Include padding in width/height calculations */
}

.super-pickem-desktop-game-info {
  text-align: center;
  color: #002129;
  font-weight: 500 !important;
  font-size: 14px !important;
}

.bracket-desktop-team-row {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #002129;
  border-radius: 4px;
  width: 200px;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0 8px;
}

.bracket-desktop-team-seed {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: #002129;
  border-radius: 4px;
}
.bracket-desktop-team-seed .seed-number {
  font-size: 20px;
  font-weight: 500;
  color: #CD942E;
}

.bracket-desktop-team-name {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  text-align: center;
}
.bracket-desktop-team-name .team-name {
  font-size: 14px;
  font-weight: 700;
  color: #002129;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Brackets/SixteenTeamBracket/BracketGameDesktop.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;AACJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;;AAKA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAFR;;AAOA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAMI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAJR;;AASA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AANF;AASE;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPN;;AAYA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AATF;AAWE;EACI,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AATN;;AAcA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAXF;AAaE;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAXN;;AAiBA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,gCAAA;EACA,aAAA,EAAA,iCAAA;EACA,sBAAA,EAAA,iDAAA;EACA,kBAAA;AAdJ;AAiBI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AAfR;AAkBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AAhBR;;AAsBA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,gCAAA;EACA,aAAA,EAAA,iCAAA;EACA,sBAAA,EAAA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAnBJ;AAqBI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;AAnBR;AAsBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;AApBR;;AA0BQ;EACI,aAAA;AAvBZ;AA2BQ;EACI,aAAA;AAzBZ;;AAgCQ;EACI,aAAA;AA7BZ;AAiCQ;EACI,aAAA;AA/BZ;;AAuCQ;EACI,aAAA;AApCZ;AAwCQ;EACI,aAAA;AAtCZ;;AA8CQ;EACI,aAAA;AA3CZ;;AAkDQ;EACI,aAAA;AA/CZ;AAsDQ;EACI,aAAA;AApDZ;;AA8DQ;EACI,aAAA;AA3DZ;AA+DQ;EACI,aAAA;AA7DZ;AAiEQ;EACI,aAAA;AA/DZ;AAmEQ;EACI,aAAA;AAjEZ;;AAsEI;EACI,aAAA;AAnER;;AAuEI;EACI,aAAA;AApER;;AAuEA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,gCAAA;EACA,aAAA,EAAA,iCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA,EAAA,iDAAA;AApEF;;AAuEA;EACI,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;AApEJ;;AAyEA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAtEJ;;AAyEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAtEJ;AAwEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAtER;;AA0EA;EACI,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAvEJ;AAyEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAvER","sourcesContent":[".super-pickem-bracket-desktop-team-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #fff;\n    border: 1px solid #002129;\n    border-radius: 4px;\n    width: 200px;\n    height: 40px;\n    min-height: 40px;\n    gap: 5px; // Space between items\n    box-sizing: border-box; // Ensure padding is included in total width\n    cursor: pointer;\n}\n\n.super-pickem-bracket-desktop-team-row-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #fff;\n    border: 1px solid #002129;\n    border-radius: 4px;\n    width: 200px;\n    height: 40px;\n    gap: 5px; // Space between items\n    box-sizing: border-box; // Ensure padding is included in total width\n}\n\n// First Part: Seed Box\n.super-pickem-bracket-desktop-team-seed {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 30px; // Fixed width\n    height: 30px; // Fixed height\n    background-color: #002129;\n    border-radius: 4px;\n\n    .seed-number {\n        font-size: 20px;\n        font-weight: 500;\n        color: #CD942E;\n    }\n}\n\n// Second Part: Logo Placeholder\n.super-pickem-bracket-desktop-team-logo-placeholder {\n    width: 30px; // Fixed width\n    height: 30px; // Fixed height\n    background-color: transparent; // Placeholder background color\n    border-radius: 4px;\n    display: flex; // Center the logo\n    justify-content: center;\n    align-items: center;\n\n    .team-logo {\n        width: 100%; // Make the image take up full width of the container\n        height: 100%; // Make the image take up full height of the container\n        object-fit: contain; // Ensure the image scales proportionally within the box\n        border-radius: 4px; // Optional: Matches the placeholder border radius\n    }\n}\n\n// Third Part: Team Name\n.super-pickem-bracket-desktop-team-name {\n    text-align: center; // Center text within space\n    display: flex;\n    width: 135px;\n    height: 30px;\n    justify-content: center;\n    align-items: center;\n    text-align: left;\n\n    .team-name {\n        font-size: 14px;\n        font-weight: 700;\n        color: #002129;\n        white-space: nowrap; // Prevent wrapping\n        overflow: hidden; // Hide overflow\n        text-overflow: ellipsis; // Add ellipsis for long text\n        line-height: 1;\n\n    }\n}\n\n.super-pickem-live-bracket-desktop-team-name {\n  text-align: center; // Center text within space\n  display: flex;\n  width: 95px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n\n\n  .team-name {\n      font-size: 14px;\n      font-weight: 700;\n      color: #002129;\n      white-space: nowrap; // Prevent wrapping\n      overflow: hidden; // Hide overflow\n      text-overflow: ellipsis; // Add ellipsis for long text\n\n  }\n}\n\n.super-pickem-live-bracket-desktop-team-score {\n  text-align: center; // Center text within space\n  display: flex;\n  width: 40px;\n  height: 38px;\n  justify-content: center;\n  border-left: 1px solid #002129;\n  align-items: center;\n\n  .team-score {\n      font-size: 14px;\n      color: #002129;\n      white-space: nowrap; // Prevent wrapping\n      overflow: hidden; // Hide overflow\n      text-overflow: ellipsis; // Add ellipsis for long text\n\n  }\n}\n\n.super-pickem-live-bracket-desktop-team-name-loser {\n  text-align: center; // Center text within space\n  display: flex;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n\n  .team-name-loser {\n      font-size: 14px;\n      font-weight: 700;\n      color: #002129;\n      white-space: nowrap; // Prevent wrapping\n      overflow: hidden; // Hide overflow\n      text-overflow: ellipsis; // Add ellipsis for long text\n\n  }\n}\n\n\n.super-pickem-bracket-desktop-game-container {\n    width: 230px;\n    height: 130px;\n    background-color: #D9D9D9;\n    border-radius: 4px;\n    border: 1px solid #002129;\n    display: flex;\n    flex-direction: column; /* Arrange children in a column */\n    justify-content: space-between; /* Space out the rows evenly */\n    align-items: center; /* Center content horizontally */\n    padding: 10px; /* Add some padding for spacing */\n    box-sizing: border-box; /* Include padding in width/height calculations */\n    position: relative; // Ensures the pseudo-element is positioned relative to this box\n    // margin-left: 53px; // Add spacing between games\n\n    &::after {\n        content: \"\";\n        position: absolute;\n        left: 100%; // Places the line at the right edge\n        top: 50%; // Centers it vertically\n        transform: translateY(-50%); // Ensures vertical centering\n        width: 7px; // Line extends 15px to the right\n        height: 2px; // Line thickness\n        background-color: black; // Solid black color\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        right: 100%;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 7px;\n        height: 2px;\n        background-color: black;\n    }\n\n}\n\n\n.super-pickem-bracket-desktop-game-container-desktop {\n    width: 206px;\n    height: 130px;\n    background-color: #D9D9D9;\n    border-radius: 4px;\n    border: 1px solid #002129;\n    display: flex;\n    flex-direction: column; /* Arrange children in a column */\n    justify-content: space-between; /* Space out the rows evenly */\n    align-items: center; /* Center content horizontally */\n    padding: 10px; /* Add some padding for spacing */\n    box-sizing: border-box; /* Include padding in width/height calculations */\n    position: relative; // Ensures the pseudo-element is positioned relative to this box\n    margin-left: 9px; // Add spacing between games\n\n    &::after {\n        content: \"\";\n        position: absolute;\n        left: 100%; // Places the line at the right edge\n        top: 50%; // Centers it vertically\n        transform: translateY(-50%); // Ensures vertical centering\n        width: 15px; // Line extends 15px to the right\n        height: 2px; // Line thickness\n        background-color: black; // Solid black color\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        right: 100%;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 15px;\n        height: 2px;\n        background-color: black;\n    }\n\n}\n.regional-bracket-desktop-column-games-third.right {\n    .super-pickem-bracket-desktop-game-container {\n        &::after {\n            display: none;\n        }\n    }\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::after {\n            display: none;\n        }\n    }\n}\n\n.regional-bracket-desktop-column-games-third.left {\n    .super-pickem-bracket-desktop-game-container {\n        &::before {\n            display: none;\n        }\n    }\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::before {\n            display: none;\n        }\n    }\n}\n\n// Remove left line from first column games\n.regional-bracket-desktop-column-games-first {\n    .super-pickem-bracket-desktop-game-container {\n        &::before {\n            display: none;\n        }\n    }\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::before {\n            display: none;\n        }\n    }\n}\n\n// Remove left line from first column games\n.regional-bracket-desktop-column-games-first-desktop-left {\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::after {\n            display: none;\n        }\n    }\n}\n\n.regional-bracket-desktop-column-games-first-desktop-right {\n    .super-pickem-bracket-desktop-game-container {\n        &::after {\n            display: none;\n        }\n        // &::before {\n        //     display: none;\n        // }\n    }\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::after {\n            display: none;\n        }\n        // &::before {\n        //     display: none;\n        // }\n    }\n}\n\n.regional-bracket-desktop-column-games-final{\n    .super-pickem-bracket-desktop-game-container {\n        &::after {\n            display: none;\n        }\n    }\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::after {\n            display: none;\n        }\n    }\n    .super-pickem-bracket-desktop-game-container {\n        &::before {\n            display: none;\n        }\n    }\n    .super-pickem-bracket-desktop-game-container-desktop {\n        &::before {\n            display: none;\n        }\n    }\n}\n.final-four-left{\n    .super-pickem-bracket-desktop-game-container::before {\n        display: none;\n    }\n}\n.final-four-right {\n    .super-pickem-bracket-desktop-game-container::after {\n        display: none;\n    }\n}\n.super-pickem-bracket-desktop-champ-container {\n  width: 219px;\n  height: 245px;\n  background-color: #D9D9D9;\n  border-radius: 4px;\n  border: 1px solid #002129;\n  display: flex;\n  flex-direction: column; /* Arrange children in a column */\n  justify-content: space-between; /* Space out the rows evenly */\n  align-items: center; /* Center content horizontally */\n  padding: 10px; /* Add some padding for spacing */\n  margin-top: -120px;\n  margin-bottom: 79px;\n  box-sizing: border-box; /* Include padding in width/height calculations */\n}\n\n.super-pickem-desktop-game-info {\n    text-align: center;\n    color: #002129;\n    font-weight: 500 !important;\n    font-size: 14px !important;\n}\n\n\n\n.bracket-desktop-team-row {\n    display: flex;\n    align-items: center;\n    background-color: #fff;\n    border: 1px solid #002129;\n    border-radius: 4px;\n    width: 200px;\n    height: 40px;\n    box-sizing: border-box;\n    cursor: pointer;\n    padding: 0 8px; // Ensure spacing on sides\n}\n\n.bracket-desktop-team-seed {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 30px; // Fixed width\n    height: 30px;\n    background-color: #002129;\n    border-radius: 4px;\n\n    .seed-number {\n        font-size: 20px;\n        font-weight: 500;\n        color: #CD942E;\n    }\n}\n\n.bracket-desktop-team-name {\n    flex: 1; // ✅ This allows it to take up remaining space\n    display: flex;\n    justify-content: center; // ✅ Center text within the div\n    align-items: center;\n    height: 30px;\n    text-align: center; // ✅ Ensure text stays centered\n\n    .team-name {\n        font-size: 14px;\n        font-weight: 700;\n        color: #002129;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        line-height: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
